<template>
    <div :class="['coin-buy-list', `gap-${gap}`]" v-if="dataPops.length > 0">
        <div class="coin-buy-item" v-for="item in dataPops" :key="item.id" @click="exchange(item)">
            <img class="coin-buy-item-img" src="@/assets/gameCoin/game-coin-icon.png">
            <p class="coin-number">{{ item.gameCoin }}</p>
            <div class="diamond-concert flex align-center">
                <span class="diamond-number">{{ item.amount }}</span>
                <img :src="item.icon">
            </div>
        </div>
    </div>
</template>

<script>
import { exchangeGameCoin } from '@/api'
import { Toast } from 'vant';
import { appFunc_LiveCoinsExchangeUse, appFunc_LiveCoinsExchangeBuyDiamond, appFunc_LiveCoinsExchangeBuyGold } from '@/utils/bridge'
import { currencyTypes } from '@/utils/constant'

export default {
    props: {
        dataPops: {
            type: Array,
            default: () => []
        },
        refreshUserInfo: {
            type: Function,
            default: () => ({})
        },
        gap: {
            type: Number,
            default: 8
        }
    },
    methods: {
        exchange(item) {
            const currency = currencyTypes[item.currencyType] || '金币'
            const popupObj = {
                cancleText: this.$t('取消'),
                confirmText: this.$t('确定兑换'),
                popupTitle: this.$t('兑换游戏币'),
                sureText: this.$t('确定将xx兑换为游戏币吗?', {name: this.$t(currency) }),
                configId: item.id,
                isUse: false
            }
            this.$emit('handleShowPopup', popupObj)
        },
     confirmExchange(configId) {
            const { aplus_queue } = window
            aplus_queue.push({
                action: 'aplus.record',
                arguments: ['Game_currency_exchange', 'CLK', { source: '游戏币兑换' }]
            })
            return new Promise((resolve, reject) => {
                exchangeGameCoin(configId).then(res => {
                    if (res.code === 1001) {
                        Toast(this.$t('兑换成功'))
                        this.refreshUserInfo()
                        appFunc_LiveCoinsExchangeUse(1)
                    } else {
                        res.code === 10301 ? appFunc_LiveCoinsExchangeBuyDiamond() : appFunc_LiveCoinsExchangeBuyGold()
                    }
                    resolve()
                })
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.coin-buy-list {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    padding-top: 16px;

    .coin-buy-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        /* height: 135px; */
        background: #32296A;
        border-radius: 12px;
        padding: 19px 0 12px;
        box-sizing: border-box;

        .coin-buy-item-img {
            width: 44px;
            height: 44px;
        }

        .coin-number {
            font-family: "HarmonyOs_Bold";
            font-weight: bold;
            font-size: 20px;
            color: #FFFFFF;
            text-align: center;
            padding: 6px 0 8px;
        }

        .diamond-concert {
            font-weight: 500;
            font-size: 16px;
            color: rgba(255, 255, 255, 0.9);
            text-align: center;
            font-family: "HarmonyOs_Medium";

            img {
                width: 20px;
                height: 20px;
                margin-left: 2px;
            }
        }
    }
}
.gap-12 {
    gap: 12px;
}
.gap-8 {
    gap: 8px;
}
</style>